import { jsx as n } from "react/jsx-runtime";
import { c as A } from "react/compiler-runtime";
import { Avatar as c } from "@mui/material";
function u(h) {
  const t = A(18);
  let r, l, i, e, s;
  t[0] !== h ? ({
    width: s,
    height: l,
    sx: e,
    children: r,
    ...i
  } = h, t[0] = h, t[1] = r, t[2] = l, t[3] = i, t[4] = e, t[5] = s) : (r = t[1], l = t[2], i = t[3], e = t[4], s = t[5]);
  let a;
  t[6] !== l || t[7] !== s ? (a = {
    width: s,
    height: l
  }, t[6] = l, t[7] = s, t[8] = a) : a = t[8];
  let f;
  t[9] !== e ? (f = Array.isArray(e) ? e : [e], t[9] = e, t[10] = f) : f = t[10];
  let o;
  t[11] !== a || t[12] !== f ? (o = [a, ...f], t[11] = a, t[12] = f, t[13] = o) : o = t[13];
  let m;
  return t[14] !== r || t[15] !== i || t[16] !== o ? (m = /* @__PURE__ */ n(c, { sx: o, ...i, children: r }), t[14] = r, t[15] = i, t[16] = o, t[17] = m) : m = t[17], m;
}
export {
  u as Avatar
};
